import axios from "axios";

import { toastify } from "../components/common/notification";

import { url } from ".";

import { LogParam } from "../types/logParam";
import { errorMessage } from "../utils/common";
import { logError, logInfo } from "../utils/logger";


// always set function name and message for every executable block
// data is optional
const logParams : LogParam = {
  applicationName : "Orchestrator Client",
  screenModuleName: "client\\src\\controllers\\auditLogs.ts",
  functionName: "",
  message: "",
}

export type AuditLogT = {
  _id: string;
  entityId: string;
  actionedBy: { name: string; role: string };
  action: string;
  entity: string;
  organization: string | string[];
  logging: string;
  changeLog?: {
    from?: Record<string, string> & { task?: string[] };
    to?: Record<string, string>  &  {
      version?: string | number;
      config?: string;
      role?: string;
      name?: string;
      type?: string;
      timezone?: string;
      queueName?: string;
      description?: string;
      expiry_date?: string;
      organization?: string[];
      email?: string;
      granted_organization?: string[];
      license?: {
        single_task_agent?: number;
        multiple_task_agent?: number;
      };
      schedulerData?: Record<string, string> & {
        organization?: string[];
        agent?: string[];
        selected_days?: string[];
        selected_dates?: string[];
        scheduled_dates?: string[];
      };
      active_status?: boolean;
      task?: string[];
      start_date?: string;
      end_date: string;
      recurrence: string;
      ocurrence: string;
      repeat: string;
      selected_days: string[];
      start_time: string;
      end_time: string;
      selected_dates: string[];
    };
  };
  createdAt: string;
};

export const agentListApi = (token: string) =>
  axios
    .get(`${url}/agent`, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      logParams.functionName = "agentListApi";
      logParams.message = "retrieved agents";
      logInfo(logParams);

      return res.data;
    })
    .catch((error) =>{
      logParams.functionName = "agentListApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export const auditTaskLogs = (token: string, pageNumber: number) =>
  axios
    .get(
      `${url}/auditLogs/${pageNumber}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      logParams.functionName = "auditTaskLogs";
      logParams.message = "retrieved audit task logs";
      logInfo(logParams);

      return res.data;
    })
    .catch((error) =>
    {
      logParams.functionName = "auditTaskLogs";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export const auditFilterLogs = (token: string, requestFilterBody: Record<string, any>) =>
  axios
    .post(`${url}/auditLogs/filteredLogs`, requestFilterBody, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    })
    .then((res) => { 
      logParams.functionName = "auditFilterLogs";
      logParams.message = "retrieved filtered audit logs";
      logInfo(logParams);

      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "auditFilterLogs";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message?.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );

export default auditTaskLogs;
